/* Aerotex aircraft finder: aircraft matches inside the existing search bars,
   and the "Shop by aircraft" type > manufacturer > model selector */
(function () {
  'use strict';
  var norm = function (s) { return String(s || '').toLowerCase().replace(/[^a-z0-9]+/g, ''); };
  var tokens = function (q) { return String(q || '').toLowerCase().split(/[\s,\/]+/).map(norm).filter(Boolean); };
  var matches = function (hay, toks) { for (var i = 0; i < toks.length; i++) if (hay.indexOf(toks[i]) === -1) return false; return true; };
  var esc = function (s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  var DATA = null;
  function data() {
    if (DATA) return DATA;
    try { DATA = JSON.parse((document.getElementById('ax-aircraft-data') || {}).textContent || '[]'); } catch (e) { DATA = []; }
    DATA.forEach(function (d) { d.h = norm(d.k); });
    return DATA;
  }

  /* ---------- Existing search bars: add aircraft matches as you type ---------- */
  function enhanceSearch(form) {
    if (form.dataset.axReady) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !data().length) return;
    form.dataset.axReady = '1';
    form.classList.add('ax-sd-host');
    input.setAttribute('autocomplete', 'off');
    var box = document.createElement('div');
    box.className = 'ax-sd'; box.hidden = true; box.setAttribute('role', 'listbox');
    box.id = 'ax-sd-' + Math.random().toString(36).slice(2, 7);
    input.setAttribute('aria-controls', box.id);
    form.appendChild(box);
    var active = -1, links = [];
    var side = form.classList.contains('rd-search-top') ? sideFilter() : null;

    function setActive(i) {
      links.forEach(function (a, j) { a.classList.toggle('is-active', j === i); a.setAttribute('aria-selected', String(j === i)); });
      active = i;
    }
    function render() {
      var q = input.value.trim(), toks = tokens(q);
      if (side) side(toks);
      if (!toks.length) { box.hidden = true; return; }
      var hits = data().filter(function (d) { return matches(d.h, toks); });
      hits.sort(function (a, b) { return (b.m ? 1 : 0) - (a.m ? 1 : 0); });
      var html = '';
      if (hits.length) {
        html += '<p class="ax-sd__h">Aircraft</p>';
        hits.slice(0, 6).forEach(function (d) {
          html += '<a class="ax-sd__item" role="option" href="' + esc(d.u) + '"><strong>' + esc(d.t) + '</strong><small>' + esc(d.s) + '</small></a>';
        });
        if (hits.length > 6) html += '<p class="ax-sd__more">+ ' + (hits.length - 6) + ' more aircraft, keep typing to narrow down</p>';
      }
      html += '<button type="submit" class="ax-sd__all">' + (hits.length ? 'Search all products for' : 'Search products for') + ' “' + esc(q.slice(0, 50)) + '” <span aria-hidden="true">→</span></button>';
      box.innerHTML = html;
      links = [].slice.call(box.querySelectorAll('.ax-sd__item'));
      active = -1;
      box.hidden = false;
    }
    input.addEventListener('input', render);
    input.addEventListener('focus', function () { if (input.value.trim()) render(); });
    input.addEventListener('keydown', function (e) {
      if (box.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); setActive(Math.min(active + 1, links.length - 1)); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); setActive(Math.max(active - 1, -1)); }
      else if (e.key === 'Enter' && active > -1 && links[active]) { e.preventDefault(); window.location.href = links[active].href; }
      else if (e.key === 'Escape') { box.hidden = true; }
    });
    document.addEventListener('click', function (e) { if (!form.contains(e.target)) box.hidden = true; });
    if (input.value.trim() && side) side(tokens(input.value));
  }

  /* Catalogue sidebar: the top search bar also narrows the "Browse the catalogue" links */
  function sideFilter() {
    var wrap = document.querySelector('.rd-collection-links');
    if (!wrap) return null;
    var groups = [].slice.call(wrap.querySelectorAll('details'));
    var initialOpen = groups.map(function (d) { return d.open; });
    var rows = [];
    groups.forEach(function (d) {
      var group = (d.querySelector('summary') || {}).textContent || '', make = '';
      [].slice.call(d.querySelectorAll(':scope > a')).forEach(function (a) {
        var isModel = a.textContent.indexOf('↳') > -1, t = a.textContent.replace('↳', '').trim();
        if (!isModel) make = t;
        rows.push({ a: a, d: d, isModel: isModel, make: make, hay: norm(group + ' ' + (isModel ? make + ' ' : '') + t) });
      });
    });
    return function (toks) {
      if (!toks.length) {
        rows.forEach(function (r) { r.a.hidden = false; });
        groups.forEach(function (d, i) { d.hidden = false; d.open = initialOpen[i]; });
        return;
      }
      var hit = rows.filter(function (r) { return matches(r.hay, toks); });
      if (!hit.length) {
        // Not an aircraft (e.g. a part number): leave the sidebar as it was
        rows.forEach(function (r) { r.a.hidden = false; });
        groups.forEach(function (d, i) { d.hidden = false; d.open = initialOpen[i]; });
        return;
      }
      var keepMakes = {};
      rows.forEach(function (r) {
        var show = matches(r.hay, toks) || (r.isModel && rows.some(function (x) { return !x.isModel && x.d === r.d && x.make === r.make && matches(x.hay, toks); }));
        r.a.hidden = !show;
        if (show && r.isModel) keepMakes[groups.indexOf(r.d) + '|' + r.make] = 1;
      });
      rows.forEach(function (r) { if (!r.isModel && keepMakes[groups.indexOf(r.d) + '|' + r.make]) r.a.hidden = false; });
      groups.forEach(function (d) { var any = rows.some(function (r) { return r.d === d && !r.a.hidden; }); d.hidden = !any; d.open = any; });
    };
  }

  /* ---------- Shop by aircraft: type > manufacturer > model ---------- */
  function initShop(root) {
    if (root.dataset.axReady) return;
    root.dataset.axReady = '1';
    var tree = [], dataEl = root.querySelector('[data-ax-shop-data]');
    try { tree = JSON.parse(dataEl.textContent); } catch (e) { return; }
    var makeLabel = dataEl.dataset.makeLabel || 'Select make';
    var type = root.querySelector('[data-ax-shop-type]');
    var make = root.querySelector('[data-ax-shop-make]');
    var model = root.querySelector('[data-ax-shop-model]');
    var go = root.querySelector('[data-ax-shop-go]');
    var fill = function (sel, first, list) {
      if (!sel) return;
      sel.innerHTML = '<option value="">' + first + '</option>' + list.map(function (x, i) { return '<option value="' + i + '">' + esc(x.t) + '</option>'; }).join('');
      sel.disabled = !list.length;
    };
    var target = function () {
      var t = tree[type.value]; if (!t) return '';
      var mk = make && t.makes[make.value]; if (!mk) return t.u;
      var md = model && mk.models[model.value]; return md ? md.u : mk.u;
    };
    var sync = function () { root.classList.toggle('is-ready', !!target()); };
    type.addEventListener('change', function () {
      var t = tree[type.value];
      fill(make, makeLabel, t ? t.makes : []);
      fill(model, 'All models', []);
      sync();
      // Single-level pickers go straight to the page
      if (!make && t) window.location.href = t.u;
    });
    if (make) make.addEventListener('change', function () {
      var mk = (tree[type.value] || { makes: [] }).makes[make.value];
      fill(model, 'All models', mk ? mk.models : []);
      sync();
    });
    if (model) model.addEventListener('change', sync);
    go.addEventListener('click', function () {
      var u = target();
      if (u) { window.location.href = u; return; }
      type.focus(); root.classList.remove('is-nudge'); void root.offsetWidth; root.classList.add('is-nudge');
    });
    sync();
  }

  /* ---------- On-page filter bar (seatbelts, cargo nets, certifications) ---------- */
  function initPageFilter(root) {
    if (root.dataset.axReady) return;
    root.dataset.axReady = '1';
    var cards = [].slice.call(document.querySelectorAll(root.dataset.cards || '_none'));
    var extra = [].slice.call(document.querySelectorAll(root.dataset.extra || '_none'));
    var q = root.querySelector('[data-ax-pf-q]'), sel = root.querySelector('[data-ax-pf-type]'), jump = root.querySelector('[data-ax-pf-jump]');
    var count = root.querySelector('[data-ax-pf-count]'), noun = root.dataset.noun || 'items';
    var buttons = root.dataset.buttons ? [].slice.call(document.querySelectorAll(root.dataset.buttons)) : [];
    var groupAttr = root.dataset.groupAttr, groupSel = root.dataset.groupSel;
    var groupOf = function (c) {
      if (groupAttr) return c.getAttribute(groupAttr) || '';
      if (groupSel) { var e = c.querySelector(groupSel); return e ? e.textContent.trim() : ''; }
      return '';
    };
    var title = function (s) { return s === s.toUpperCase() ? s.toLowerCase().replace(/(^|\s|\/|\(|&)([a-z])/g, function (m, a, b) { return a + b.toUpperCase(); }).replace(/\bFaa\b/, 'FAA') : s; };
    cards.forEach(function (c) { c.dataset.axHay = norm(c.textContent); });
    extra.forEach(function (c) { c.dataset.axHay = norm(c.textContent); });
    if (sel) {
      var opts = [];
      if (buttons.length) buttons.forEach(function (b) { var v = b.dataset.beltFilter; if (v && v !== 'All') opts.push([v, b.textContent.trim()]); });
      else cards.forEach(function (c) { var g = groupOf(c); if (g && !opts.some(function (o) { return o[0] === g; })) opts.push([g, title(g)]); });
      if (!opts.length) sel.closest('.ax-shop__field').hidden = true;
      opts.forEach(function (o) { var op = document.createElement('option'); op.value = o[0]; op.textContent = o[1]; sel.appendChild(op); });
    }
    if (jump) {
      [].slice.call(document.querySelectorAll(root.dataset.jumpLinks || '_none')).forEach(function (a) { var op = document.createElement('option'); op.value = a.getAttribute('href'); op.textContent = a.textContent.trim(); jump.appendChild(op); });
      jump.addEventListener('change', function () { var t = jump.value && document.querySelector(jump.value); if (t) t.scrollIntoView({ behavior: 'smooth' }); jump.value = ''; });
    }
    var scrollTarget = root.dataset.scroll && document.querySelector(root.dataset.scroll);
    function apply() {
      var toks = tokens(q ? q.value : ''), g = sel ? sel.value : '', shown = 0;
      cards.forEach(function (c) {
        var ok = (!g || groupOf(c) === g) && (!toks.length || matches(c.dataset.axHay, toks));
        c.hidden = !ok; if (ok) shown++;
      });
      extra.forEach(function (c) { c.hidden = !!toks.length && !matches(c.dataset.axHay, toks); });
      if (count) count.textContent = (toks.length || g) ? shown + ' of ' + cards.length + ' ' + noun : cards.length + ' ' + noun;
    }
    if (sel) sel.addEventListener('change', function () {
      if (buttons.length) { var b = buttons.filter(function (x) { return x.dataset.beltFilter === (sel.value || 'All'); })[0]; if (b) b.click(); }
      apply();
      if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth' });
    });
    buttons.forEach(function (b) { b.addEventListener('click', function () { if (sel) sel.value = b.dataset.beltFilter === 'All' ? '' : b.dataset.beltFilter; setTimeout(apply, 0); }); });
    if (q) {
      var scrolled = false;
      q.addEventListener('input', function () { apply(); if (!scrolled && scrollTarget && q.value.trim()) { scrolled = true; scrollTarget.scrollIntoView({ behavior: 'smooth' }); } if (!q.value.trim()) scrolled = false; });
      q.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); if (scrollTarget) scrollTarget.scrollIntoView({ behavior: 'smooth' }); } });
    }
    apply();
  }

  /* ---------- Sticky filter bar under the header ---------- */
  function initBar(bar) {
    if (bar.dataset.axReady) return;
    bar.dataset.axReady = '1';
    var header = document.querySelector('.header'), html = document.documentElement;
    var toggle = bar.querySelector('[data-ax-bar-toggle]');
    function measure() {
      var hs = header ? getComputedStyle(header).position : '';
      var hh = header && (hs === 'sticky' || hs === 'fixed') ? header.offsetHeight : 0;
      html.style.setProperty('--site-header-height', hh + 'px');
      html.style.setProperty('--ax-bar-h', bar.offsetHeight + 'px');
      html.style.scrollPaddingTop = (hh + bar.offsetHeight + 16) + 'px';
    }
    measure();
    window.addEventListener('resize', measure);
    if (window.ResizeObserver) { var ro = new ResizeObserver(measure); ro.observe(bar); if (header) ro.observe(header); }
    var stuck = function () { bar.classList.toggle('is-stuck', bar.getBoundingClientRect().top <= (header ? header.offsetHeight : 0) + 1 && window.scrollY > 10); };
    window.addEventListener('scroll', stuck, { passive: true }); stuck();
    if (toggle) toggle.addEventListener('click', function () { var open = bar.classList.toggle('is-open'); toggle.setAttribute('aria-expanded', String(open)); measure(); });
  }

  /* ---------- Catalogue toolbar: instant filter of this page, one-click filter chips, sort ---------- */
  function initCatalogue(root) {
    if (root.dataset.axReady) return;
    root.dataset.axReady = '1';
    var sort = root.querySelector('[data-ax-cat-sort]');
    if (sort) sort.addEventListener('change', function () { var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u; });
    root.querySelectorAll('[data-ax-cat-more]').forEach(function (b) {
      b.addEventListener('click', function () { var box = b.closest('[data-ax-cat-chips]'); var open = box.classList.toggle('is-open'); b.textContent = open ? 'Show fewer' : b.dataset.label; });
      b.dataset.label = b.textContent;
    });
    var input = root.querySelector('.ax-cat__search input[name="q"]');
    var grid = document.querySelector('.result-grid');
    var count = root.querySelector('[data-ax-cat-count]');
    var none = document.querySelector('[data-ax-cat-none]');
    if (!input || !grid || !count) return;
    var cards = [].slice.call(grid.children).filter(function (c) { return !c.classList.contains('empty-state'); });
    if (!cards.length) return;
    var base = count.textContent;
    cards.forEach(function (c) { c.dataset.axHay = norm(c.textContent); });
    input.addEventListener('input', function () {
      var toks = tokens(input.value), shown = 0;
      cards.forEach(function (c) { var ok = !toks.length || matches(c.dataset.axHay, toks); c.hidden = !ok; if (ok) shown++; });
      count.textContent = toks.length ? shown + ' of ' + cards.length + ' on this page match · press Enter to search everything' : base;
      if (none) none.hidden = !!shown || !toks.length;
    });
  }

  /* ---------- Product page: colour swatches pick the option and update the photo ---------- */
  function initPdp(root) {
    if (root.dataset.axPdp) return;
    root.dataset.axPdp = '1';
    var select = root.querySelector('[data-variant-select]'), img = document.getElementById('rd-main-image');
    var chosen = root.querySelector('[data-pdp-chosen]'), sws = [].slice.call(root.querySelectorAll('[data-pdp-variant]'));
    var product = null; try { product = JSON.parse(root.querySelector('[data-product-json]').textContent); } catch (e) {}
    function show(id) {
      var sw = sws.filter(function (b) { return b.dataset.pdpVariant === String(id); })[0];
      var v = product && product.variants.filter(function (x) { return String(x.id) === String(id); })[0];
      var src = sw ? sw.dataset.pdpImg : (v && v.featured_image ? v.featured_image.src : '');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; if (v) img.alt = product.title + ' ' + v.title; }
      if (chosen && v) chosen.textContent = v.title;
      sws.forEach(function (b) { var on = b === sw; b.classList.toggle('is-on', on); b.setAttribute('aria-checked', String(on)); });
    }
    sws.forEach(function (b) { b.addEventListener('click', function () { if (select) { select.value = b.dataset.pdpVariant; select.dispatchEvent(new Event('change', { bubbles: true })); } else show(b.dataset.pdpVariant); }); });
    if (select) select.addEventListener('change', function () { show(select.value); });
    var on = sws.filter(function (b) { return b.classList.contains('is-on'); })[0];
    if (on) { var box = on.parentNode; box.scrollTop = on.offsetTop - box.offsetTop - 60; }
  }

  function init() {
    document.querySelectorAll('form.hero-search, form.rd-search-top, form.ax-bar-search').forEach(enhanceSearch);
    document.querySelectorAll('[data-ax-bar]').forEach(initBar);
    document.querySelectorAll('[data-ax-pf]').forEach(initPageFilter);
    document.querySelectorAll('[data-ax-shop]').forEach(initShop);
    document.querySelectorAll('[data-ax-cat]').forEach(initCatalogue);
    document.querySelectorAll('.rd-pdp[data-product-detail]').forEach(initPdp);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
